import { useState } from "react";

export const ViewShipmentDetailPublish = () => {
    const [tab, setTab] = useState("tab-2");
    return (
        <>
            <div className="content_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">출하 상세보기</h3>
                    <div className="filter_toolbar">
                        <button className="btn btn-outline-primary w-100px h-38px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt="" />목록</button>
                    </div>
                </div>
                <h5 className="subheading">기본정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>출하번호</th>
                            <td style={{ width: "33.34%" }}>1234_20240505_1</td>
                            <th style={{ width: "16.66%" }}>상태</th>
                            <td>출하요청</td>
                        </tr>
                        <tr>
                            <th>출하일자</th>
                            <td>2024-05-05</td>
                            <th>요청자</th>
                            <td>이소희</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="mybtns_group">
                <div className="btn-group" role="group" aria-label="">
                    <button type="button" className={tab == "tab-1" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-1")}>출하정보</button>
                    <button type="button" className={tab == "tab-2" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-2")}>품목정보</button>
                    <button type="button" className={tab == "tab-3" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-3")}>거래처정보</button>
                    <button type="button" className={tab == "tab-4" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-4")}>이전 결제 건</button>
                    <button type="button" className={tab == "tab-5" ? "btn btn-light active" : "btn btn-light"} onClick={() => setTab("tab-5")}>출하자료</button>
                </div>
                {tab == "tab-2" && <div className="mybtns_group_toolbar">
                    <button type="button" className="btn btn-primary w-80px">출하</button>
                    <button type="button" className="btn btn-primary color2 w-80px">이관</button>
                    <button type="button" className="btn btn-info color2 w-80px ms-5px">마감</button>
                </div>}
            </div>

            {tab == "tab-2" && <div className="content_wrap">
                <h5 className="subheading">기본정보</h5>
                <table className="table table-bordered my_table table_detail">
                    <tbody>
                        <tr>
                            <th style={{ width: "16.66%" }}>환율</th>
                            <td style={{ width: "33.34%" }}>1345</td>
                            <th style={{ width: "16.66%" }}>환종</th>
                            <td>
                                <select className="form-select w-250px">
                                    <option>KRW</option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>기준일</th>
                            <td>기간 평균 환율</td>
                            <td className="p-5px" colSpan={2}>
                                <div className="d-flex align-items-center">
                                    <input type="date" className="form-control w-150px" />
                                    <span className="txt_range px-10px">~</span>
                                    <input type="date" className="form-control w-150px" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th>기준일 메모</th>
                            <td colSpan={3}>출하요청일</td>
                        </tr>
                        <tr>
                            <th>환율 지정 조건</th>
                            <td className="p-0" colSpan={3}>
                                <div className="tbl_col3"><div>매매기준율</div><div>최종 고시</div><div>소수점 절삭</div></div>
                            </td>
                        </tr>
                        <tr>
                            <th>원화 단가 단위</th>
                            <td className="p-5px" colSpan={3}>
                                <select className="form-select w-250px">
                                    <option>백단위 절삭</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <h5 className="subheading mt-15px">품목정보</h5>
                <div className="table_scroll mb-0">
                    <table className="table table-bordered my_table table_detail">
                        <thead>
                            <tr>
                                <th style={{ width: "33.08%" }}>품목</th>
                                <th style={{ width: "14.3%" }}>규격</th>
                                <th style={{ width: "12.57%" }}>단가<span className="required">*</span></th>
                                <th style={{ width: "13.2%" }}>원화 단가<span className="required">*</span></th>
                                <th style={{ width: "10.37%" }}>수량</th>
                                <th>금액</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="ellipsis">S1-Win10 IoT Ent 2021 LTSC MultiLang ESD OEI High End (PC)</div>
                                        <button className="btn btn-info btn_search w-80px ms-20px">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                        </button>
                                    </div>
                                </td>
                                <td className="text-center">MUT-00074</td>
                                <td className="text-end">$123</td>
                                <td className="text-start">￦</td>
                                <td className="text-end">5</td>
                                <td className="text-end"><div className="d-flex align-items-center justify-content-between"><div>₩</div><div>0</div></div></td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="ellipsis">Ex-001</div>
                                        <button className="btn btn-info btn_search w-80px ms-20px">
                                            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                        </button>
                                    </div>
                                </td>
                                <td className="text-center"></td>
                                <td className="text-end">$123</td>
                                <td className="text-start">￦</td>
                                <td className="text-end">2​</td>
                                <td className="text-end"><div className="d-flex align-items-center justify-content-between"><div>₩</div><div>0</div></div></td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr className="blue">
                                <td className="text-center" colSpan={4}>합 계​</td>
                                <td className="text-end">2</td>
                                <td className="text-end"><div className="d-flex align-items-center justify-content-between"><div>₩</div><div>132800​</div></div></td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>}
        </>
    );
}